import { Map, List, fromJS } from 'immutable'

export function coordinationLoading(state = false, action) {
  if (action.type === 'COORDINATION_LOADING') return action.loading || false

  if (action.type === 'COORDINATION_LOAD_SUCCESS' || action.type === 'COORDINATION_LOAD_ERROR') return false

  return state
}

export function coordinationError(state = false, action) {
  if (action.type === 'COORDINATION_LOAD_ERROR') return action.message || 'Error happened'

  if (action.type === 'COORDINATION_LOAD_SUCCESS') return false

  return state
}

export function coordinationData(state = Map(), action) {
  if (action.type === 'COORDINATION_LOAD_SUCCESS') {
    if (!Map.isMap(action.data)) return fromJS(action.data)

    return action.data
  }

  return state
}
